import PropTypes from 'prop-types';
import React from 'react';
import { FaSearch } from 'react-icons/fa';
import { GrClose } from 'react-icons/gr';

import Button, { ButtonAppearance } from '../../../../../../ui/Atoms/Button';
import { SearchEngine } from './SearchEngine';

import * as S from './SearchBar.styles';

export const SearchBar = ({
  isMobile,
  isSearchBarDisplayed,
  setIsSearchBarDisplayed,
  placeholder,
  lang,
  isEvent,
}) => (
  <>
    {isSearchBarDisplayed && (
      <S.SearchContainer>
        <Button
          appearance={ButtonAppearance.CIRCULAR}
          onClick={() => setIsSearchBarDisplayed(!isSearchBarDisplayed)}
        >
          <GrClose />
        </Button>
        <SearchEngine
          autoFocus={isSearchBarDisplayed}
          lang={lang}
          placeholder={placeholder}
          isEvent={isEvent}
        />
      </S.SearchContainer>
    )}
    <S.ButtonWrapper
      isMobile={isMobile}
      isSearchBarDisplayed={isSearchBarDisplayed}
    >
      <Button
        appearance={ButtonAppearance.CIRCULAR}
        onClick={() => setIsSearchBarDisplayed(!isSearchBarDisplayed)}
      >
        {!isSearchBarDisplayed ? <FaSearch /> : !isMobile && <GrClose />}
      </Button>
    </S.ButtonWrapper>
  </>
);

SearchBar.propTypes = {
  isMobile: PropTypes.bool,
  isSearchBarDisplayed: PropTypes.bool,
  setIsSearchBarDisplayed: PropTypes.func,
  placeholder: PropTypes.string,
  lang: PropTypes.string,
  isEvent: PropTypes.bool,
};
